import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { ErrorFallback } from "@/components/ErrorFallback";
import { AppRoutes } from "@/routes/AppRoutes";
import { store } from "@/store";

import "@datamole/wds-css-layer";
import "@datamole/wds-css-normalize";
import "@/styles/global.css";

/**
 * Component representing the main application
 *
 * @returns rendered application
 */
const App = () => {
    return (
        <Provider store={store}>
            <ErrorBoundary fallback={<ErrorFallback />}>
                <BrowserRouter>
                    <AppRoutes />
                </BrowserRouter>
            </ErrorBoundary>
        </Provider>
    );
};

export { App };
